import { ethers } from "ethers";
import { useEffect, useState } from "react";
import NFTVaultABI from "src/assets/abis/NFTVaultABI.json";
import { NftBalanceConfig } from "src/config/balance/travaBalanceConfig";
import { NETWORK } from "src/config/constants";
import { useNetworkProviderSelector } from "src/ether-utils/context/providerContext";
import { convertBigNumber } from "src/ether-utils/utils";

export default function useNFTBalance(accountAddress) {
  const [nftBalance, setNFTBalance] = useState(0);
  const bscProvider = useNetworkProviderSelector(NETWORK.BSC_MAINNET);

  const _fetchNFTBalance = async (accountAddress, contractAddress, _provider) => {
    const NFTContract = new ethers.Contract(contractAddress, NFTVaultABI, _provider);
    const balanceTrava = await NFTContract.getTotalRewardsBalance(accountAddress);
    return convertBigNumber(balanceTrava, 18, 2);
  };

  const _fetchAllNFTBalance = async (accountAddress) => {
    const result = await Promise.all(
      NftBalanceConfig.map((contractAddress) => {
        return _fetchNFTBalance(accountAddress, contractAddress, bscProvider);
      })
    );
    return result;
  };

  useEffect(() => {
    if (bscProvider) {
      _fetchAllNFTBalance(accountAddress)
        .then((data) => {
          setNFTBalance(data.reduce((x, y) => x + y));
        })
        .catch((error) => {
          console.error("fetch nft balance error: ", error);
        });
    }
  }, [accountAddress, bscProvider]);

  return nftBalance;
}
